import { reactive } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'searchBlock',
  emits: ['search'],
  setup(__props, {
    emit
  }) {
    const filter = reactive({
      schemeName: '',
      enable: null
    });
    const statusOptions = [{
      label: '开启',
      value: 1
    }, {
      label: '关闭',
      value: 0
    }];
    const onSearch = () => {
      var _filter$schemeName;
      const param = {
        schemeName: ((_filter$schemeName = filter.schemeName) === null || _filter$schemeName === void 0 ? void 0 : _filter$schemeName.trim()) || undefined,
        enable: filter.enable === 0 || filter.enable === 1 ? filter.enable : undefined
      };
      // 移除 undefined 值
      Object.keys(param).forEach(key => param[key] === undefined && delete param[key]);
      emit('search', param);
    };
    const onClear = () => {
      filter.schemeName = '';
      filter.enable = null;
      onSearch();
    };
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_form, {
        layout: "horizontal",
        model: filter,
        class: "form_wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_input_search, {
            value: filter.schemeName,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => filter.schemeName = $event),
            placeholder: "方案名称",
            onSearch: onSearch,
            onPressEnter: onSearch
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            allowClear: "",
            value: filter.enable,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => filter.enable = $event),
            placeholder: "请选择状态",
            showArrow: true,
            options: statusOptions,
            onChange: onSearch
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            class: "reset-button",
            onClick: onClear
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_a_button, {
            class: "search-button",
            type: "primary",
            onClick: onSearch
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};